import { render, staticRenderFns } from "./Cash.vue?vue&type=template&id=2a20b916&scoped=true&"
import script from "./Cash.vue?vue&type=script&lang=js&"
export * from "./Cash.vue?vue&type=script&lang=js&"
import style0 from "./Cash.vue?vue&type=style&index=0&id=2a20b916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a20b916",
  null
  
)

export default component.exports